import { MailCheck } from "lucide-react";

const manifest = {
  key: "communication_management",
  isFreeModule: true,
  isPurchasable: false,
  icon: MailCheck,
  names: {
    plan: {
      en: "Communication Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u062a\u0648\u0627\u0635\u0644",
      "zh-Hans": "通信管理",
    },
    dashboard: {
      en: "Communication Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u062a\u0648\u0627\u0635\u0644",
      "zh-Hans": "通信管理",
    },
  },
  defaultPath: "/communication-management",
  matchers: [/^\/communication-management(?:\/|$)/],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__communication_management__",
      children: [
        {
          label: t("contactUs"),
          path: "https://tarhplatform.com/contact",
        },
      ],
    },
  ],
};

export default manifest;
